import { gql } from '@apollo/client';

const queryCheckEmail = gql`
    query checkEmail($email: String!) {
        checkEmail(email: $email) {
            status
            messagecode
            message
            data
        }
    }
`;

const querySendEmailTemplate = gql`
  query sendEmailTemplate($template_type: String!, $objectData: JSON) {
    sendEmailTemplate(template_type: $template_type, objectData: $objectData) {
      status
      message
    }
  }
`;

const queryAccountVerification = gql`
    query account_verification ($email: String!) {
        account_verification(email: $email) {
        status
        message
        messagecode
        }
    }
`;

const queryGetProfile = gql`
    query getProfile($user_id: String!) {
        getProfile(user_id: $user_id) {
            user_id 
            first_name 
            middle_name 
            last_name,
            username,
            role_id,
            mfa_enabled,
            mfa_number,
            mfa_country,
            created_at,
            updated_at,
            sso_enabled,
            preferences {                
            preference_type
            preference_name
            preference_value
            preference_information
            }
        }
    }
`;

const queryGetUserPreferences = gql`
    query getUserPreferences($user_id: String!) {
        getUserPreferences(user_id: $user_id) {
            preference_name,
            preference_id,
            preference_value,
            preference_information
        }
    }
`;

const queryDefaultTenant = gql`
    query defaultTenant($email: String!) {
        defaultTenant(email: $email) {
        customer_name
        display_name
        }
        }
`;

const queryLoginCustom = gql`
    query loginCustom($email: String!, $password:String!, $timezone: String) {
        loginCustom(email: $email, password: $password, timezone: $timezone) {
            status
            message
            data
            messagecode
        }
    }
`;

const queryPasswordWrong = gql`
    query passwordWrong($email: String!) {
        passwordWrong(email: $email) {
        status
        message
        data
        messagecode
        }
    }
`;

const queryResendLink = gql`
    query resendLink($email: String!, $brand: String) {
        resendLink(email: $email, brand: $brand) {
        status
        message
        }
    }
`;

const queryGetRoleList = gql`
    query getRoleList($customer_name: String!) {
        getRoleList(customer_name: $customer_name) {
            role_id
            active
            role_name
            role_description
            deleted
            created_at
            updated_at
            system_flag
            role_alias
            cascaded_role_id
        }
    }
`;

const queryGetRole = gql`
    query getRole($roleid: String!, $schema: String!) {
        getRole(roleid: $roleid, schemaname: $schema) {
            status
            data
            message
            messagecode
        }
    }
`;

const queryGetBillingDetails = gql`
    query getBillingDetails($username: String!) {
        getBillingDetails(username: $username) {
            status
            messagecode
            message
            data
        }
    }
`;

const queryGetAdminUsers = gql`
    query getAdminUsers($customer_name: String!, $search: String) {
        getAdminUsers(customer_name: $customer_name, search: $search) {
            user_id,
            role_id,
            first_name,
            middle_name,
            last_name,
            username,
            active,
            user_locked,
            mfa_enabled,
            deleted,
            mfa_enabled,
            auth_type,
            department_id,
            password_create,
            totalsessions,
            system_flagged
            last_login_at
            department{
                department_alias
                department_name
                enterprise_billing
            }
        }
    }
`;

const queryGetUserDetails = gql`
    query getUserDetails($customer_name: String!,$user_id: Float!) {
        getUserDetails(customer_name: $customer_name,user_id: $user_id) {
            user_id,
            first_name,
            last_name,
            middle_name,
            username,
            active,
            preferences{
            preference_id
            preference_type
            preference_name
            preference_value
            preference_information
            }
        }
    }
`;

const getStripeProductsList = gql`
    query getStripeProductsList {
        getStripeProductsList {
          data
          message
          messagecode
          status
        }
    }
`;

const getStripeCheckoutSession = gql`
    query getStripeCheckoutSession($email: String!, $priceid: String!, $usagepriceid: String!, $domain: String!, $success: String!, $failure: String! ) {
        getStripeCheckoutSession(email: $email, priceid: $priceid, usagepriceid: $usagepriceid, domain: $domain, success: $success, failure: $failure) {
          data
          message
          status
        }
    }
`;

const getStripeCheckoutSessionData = gql`
    query getStripeCheckoutSessionData($sessionid: String!) {
        getStripeCheckoutSessionData(sessionid: $sessionid) {
          data
          message
          status
        }
    }
`;

const getStripePortalUrl = gql`
    query getStripePortalUrl($customerid: String!, $returnurl: String) {
        getStripePortalUrl(customerid: $customerid, returnurl: $returnurl ) {
          data
          message
          messagecode
          status
        }
    }
`;



const getStripePortal = gql`
    query getStripePortal($customerid: String!) {
        getStripePortal(customerid: $customerid ) {
          data
          message
          status
        }
    }
`;

const getGavatarImage = gql`
  query getGavatarImage($email: String!) {
    getGavatarImage(email: $email) {
      status
      messagecode
      data
    }
  }
`;

export {
  queryCheckEmail,
  querySendEmailTemplate,
  queryAccountVerification,
  queryGetProfile,
  queryGetUserPreferences,
  queryDefaultTenant,
  queryLoginCustom,
  queryPasswordWrong,
  queryResendLink,
  queryGetRoleList,
  queryGetRole,
  queryGetBillingDetails,
  queryGetAdminUsers,
  queryGetUserDetails,
  getStripeProductsList,
  getStripeCheckoutSession,
  getStripeCheckoutSessionData,
  getStripePortalUrl,
  getStripePortal,
  getGavatarImage
};
